"use strict";

export default angular.module("contartemx.administracion.cuentas")
    .controller("ReactivarCuentaContribuyenteCtrl", ($scope, $uibModalInstance, apiCall, mostrarNotificacion, cuenta) => {

        $scope.loading = false;

        $scope.closeModal = (respuesta) => {
            $uibModalInstance.dismiss();
        };


        $scope.reactivarContribuyente = () => {

            $scope.loading = true;

            let datosEnviar = {};
            datosEnviar.CveContribuyente = cuenta.ClaveContribuyente;

            apiCall.post('ReactivarCuentaContribuyente', datosEnviar)
                .then((data) => {
                    if (data.EsError) {
                        $scope.alert = [{ msg: data.Mensaje }];
                    } else {
                        $uibModalInstance.close(data);
                    }
                },
                mostrarNotificacion.error)
                .finally(() => $scope.loading = false);

        };

        $scope.closeModalAlert = index => {  
            $scope.alert.splice(index, 1);
        };

    });
